import React, { useEffect, useState, useCallback } from 'react';
import {
    IonContent,
    IonPage,
    IonImg,
    IonIcon,
    IonLoading, useIonAlert, IonCol, IonRow, IonDatetime, IonModal,
} from '@ionic/react';
import {
    chevronBack,
    chevronForward,
    addCircle, trash, eye, pencil, calendarOutline, addOutline
} from 'ionicons/icons';

import AddNewsLetterModal from "../../components/AddNewsLetterModal";
import useStore from "../../zustand/useStore";
import {
    actionToDeleteEventPostData,
    actionToDeleteNewsLetterPostData,
    actionToGetNewsLettersByFilter
} from "../../apiHelpers/CommonAction";
import {FacebookLoader} from "../../components/Loader/FacebookLoader";
import NewsLetterDetailModal from "../../components/NewsLetterDetailModal";

const ITEMS_PER_PAGE = 10;
const today = new Date();
const currentMonth = today.getMonth() + 1; // getMonth() gives 0–11, so +1

const AdminNewsletterPage = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [addNewsModalSheet, setAddNewsModalSheet] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [newsLetterData, setNewsLetterData] = useState(null);
    const [isDetailOpen,setIsDetailOpen] = useState(false);
    const [dataForEditing, setDataForEditing] = useState(null)
    const { newsLettersDataState, selectedNewsLetterDateFilter,setSelectedNewsLetterDateFilter } = useStore();
    const { newsLettersData, loading, totalCount } = newsLettersDataState;
    const [isCustomYearPickerOpen, setIsCustomYearPickerOpen] = useState(false);
    const pageCount = Math.ceil((totalCount || 0) / ITEMS_PER_PAGE);
    const [presentAlert] = useIonAlert();
    const [tempYear, setTempYear] = useState(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState('');

    const callFunctionToDeletedata = (id)=>{
        presentAlert({
            header: 'Are you sure?',
            cssClass: 'custom_site_alert_toast',
            message: 'You want to delete this item.',
            buttons: [
                {text: 'Cancel', role: 'cancel'},
                {text: 'Delete', role: 'confirm', handler: async () =>{
                        await actionToDeleteNewsLetterPostData(id)
                    }},
            ],
        });
    }
    const fetchPageData = useCallback((page, isFilter = false, news_year = tempYear, news_month = selectedMonth) => {
        const newOffset = (page - 1) * ITEMS_PER_PAGE;
        setCurrentPage(page);
        actionToGetNewsLettersByFilter(isFilter, { offset: newOffset ,news_year, news_month});
    }, [tempYear, selectedMonth]);

    useEffect(() => {
        fetchPageData(1,false, tempYear, selectedMonth);
    }, [fetchPageData]);

    const handlePrev = () => {
        if (currentPage > 1) {
            fetchPageData(currentPage - 1, false, tempYear, selectedMonth);
        }
    };

    const handleNext = () => {
        if (currentPage < pageCount) {
            fetchPageData(currentPage + 1, false, tempYear, selectedMonth);
        }
    };



    const handleYearChange = () => {
        setSelectedNewsLetterDateFilter(tempYear);
        setIsCustomYearPickerOpen(false);
        fetchPageData(1,true,tempYear, selectedMonth);
    };

    const handleMonthChange = (value) =>{
        setSelectedMonth(value)
        fetchPageData(1,true, tempYear, value)
    }


    const openNewsLatterDetailPanel = (data) => {
        setNewsLetterData(data);
        setIsDetailOpen(true)
    }

    const callFunctionToEditData = (data) =>{
        setDataForEditing(data);
        setAddNewsModalSheet(true);
    }

    return (
        <IonPage>
            <IonContent className="ion-padding news-letter-content-page">
                <div className="admin_inner_tab_container">
                    <div className="header-row">
                        <h2 className="newsletter-heading">Monthly Newsletters</h2>
                        <div className={"d-flex ml-auto newsletter-heading_right"}>
                            <IonIcon
                                className="add_news_icon addnews-btn job-portal"
                                onClick={() => setAddNewsModalSheet(true)}
                                icon={addOutline}
                            />
                            <select
                                className={"custom-select-ion"}
                                value={selectedMonth}
                                onChange={(e) => handleMonthChange(e.target.value)}
                            >
                                <option value="">All Months</option>
                                <option value="1">January</option>
                                <option value="2">February</option>
                                <option value="3">March</option>
                                <option value="4">April</option>
                                <option value="5">May</option>
                                <option value="6">June</option>
                                <option value="7">July</option>
                                <option value="8">August</option>
                                <option value="9">September</option>
                                <option value="10">October</option>
                                <option value="11">November</option>
                                <option value="12">December</option>
                            </select>
                        </div>

                    </div>

                    <IonRow>
                        <IonCol size="12" sizeMd="12">
                            <div className="desktop_events_filter newsletter-filter">
                                <div className="desktop_events_filter_grid_col">
                                    <div onClick={() => setIsCustomYearPickerOpen(true)}
                                         className={`events_tab_button`}>
                                        <IonIcon icon={calendarOutline} slot="start"/> Select Year
                                    </div>
                                </div>
                                <div className="desktop_events_filter_grid_col">
                                    <div className={`events_tab_button active`}>
                                        {selectedNewsLetterDateFilter}
                                    </div>
                                </div>
                            </div>

                        </IonCol>
                    </IonRow>

                    <div className="newsletter-table-container">
                        <table className="newsletter-table">
                            <thead>
                            <tr>
                                <th>Image</th>
                                <th>Caption</th>
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            {(loading) ?
                                <>
                                    <tr>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                    </tr>
                                </>
                            :newsLettersData?.length > 0 ? (
                                newsLettersData.map((item) => (
                                    <tr key={item.id}>
                                        <td>
                                            <IonImg src={item.image_url} className="newsletter-img" />
                                        </td>
                                        <td>{item.caption}</td>
                                        <td>{new Date(item.newsletter_date).toLocaleDateString()}</td>
                                        <td className={"action_td"}>
                                            <IonIcon icon={eye} onClick={()=>openNewsLatterDetailPanel(item)} className={"admin_delete_button_icon eye_icon"}/>
                                            <IonIcon icon={pencil} onClick={()=>callFunctionToEditData(item)} className={"admin_delete_button_icon pencil_icon"}/>
                                            <IonIcon icon={trash} onClick={()=>callFunctionToDeletedata(item?.id)} className={"admin_delete_button_icon"}/>
                                        </td>
                                        {/*<td>{item.created_by}</td>*/}
                                        {/*<td>*/}
                                        {/*    <IonButton*/}
                                        {/*        fill="clear"*/}
                                        {/*        size="small"*/}
                                        {/*        href={item.pdf_url}*/}
                                        {/*        target="_blank"*/}
                                        {/*    >*/}
                                        {/*        <IonIcon icon={eyeOutline} slot="icon-only" />*/}
                                        {/*    </IonButton>*/}
                                        {/*</td>*/}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: 'center', padding: '1rem' }}>
                                        No newsletters found.
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="pagination-controls">
                        <button
                            type="button"
                            className={"pagination_button"}
                            disabled={currentPage === 1}
                            onClick={handlePrev}
                        >
                            <IonIcon icon={chevronBack} />
                        </button>
                        <span className="page-info">
                            Page {currentPage} of {pageCount}
                        </span>
                        <button
                            type="button"
                            className={"pagination_button"}
                            disabled={currentPage === pageCount}
                            onClick={handleNext}
                        >
                            <IonIcon icon={chevronForward} />
                        </button>
                    </div>
                </div>
            </IonContent>
            <IonModal breakpoints={[0, 0.3]} initialBreakpoint={0.3} isOpen={isCustomYearPickerOpen}
                      onDidDismiss={handleYearChange}>
                <IonDatetime
                    presentation="year"
                    className={"bottom_date_picker"}
                    min={2000}
                    onIonChange={(e) => {
                        const year = new Date(e.detail.value).getFullYear();
                        setTempYear(year);
                    }}
                    value={tempYear.toString()}
                />
            </IonModal>

            {/* Modal */}
            <AddNewsLetterModal
                isOpen={addNewsModalSheet}
                dataForEditing={dataForEditing}
                onClose={() => {
                    setDataForEditing(null)
                    setAddNewsModalSheet(false)
                }}
                setIsLoading={setIsLoading}
            />

            <NewsLetterDetailModal
                isOpen={isDetailOpen}
                newsLetterDetailData={newsLetterData}
                onDidDismiss={() => setIsDetailOpen(false)}
            />

            <IonLoading
                isOpen={isLoading}
                className="loading_loader_spinner_container"
                message="Please Wait..."
            />
        </IonPage>
    );
};

export default AdminNewsletterPage;
